import { Chip, ChipProps, ThemeOptions } from '@mui/material'

export { Chip }

export type { ChipProps }

export const chipThemeOverrides: ThemeOptions['components'] = {
  
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: '4px',
        height: '24px',
      },
      icon: {
        fontSize: '18px',
      },
      /* Migrated from the app; not BS 2.0 */
      outlined: {
        backgroundColor: '#E8F0F6',
        minWidth: '40px',
        marginRight: '10px',
        border: `1px solid #B2CAE0`,
      },
      deletable: {
        backgroundColor: '#E8F0F6',
        minWidth: '40px',
        marginRight: '10px',
        border: `1px solid #B2CAE0`,
      },
      deleteIcon: {
        color: '#003F7E',
      },
    },
    /* End Migrated */
  },
}
